import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { paymentFailedPageTitle, PIQET } from '@piqet-angular/shared';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';

@Component({
  selector: 'piqet-angular-purchase-cancel',
  templateUrl: './purchase-cancel.component.html',
  styleUrls: ['./purchase-cancel.component.scss'],
})
export class PurchaseCancelComponent implements OnInit, OnDestroy {
  title = inject(Title);
  route = inject(ActivatedRoute);
  sharedService = inject(SharedService);

  ngOnInit(): void {
    this.title.setTitle(paymentFailedPageTitle);
    this.sharedService.loadGTScript();
  }

  ngOnDestroy(): void {
    this.sharedService.removeGTScript();
    this.title.setTitle(PIQET);
  }
}
